/**
 * BD Table of Contents - shared script for sections that use TOC (e.g. bd-benefits-list, article-paragraph).
 * Uses data-section-id on .bd-benefits-list__toc-wrapper to determine which section to align with.
 */
(function() {
  'use strict';

  function findElementByExactText(searchText) {
    if (!searchText || typeof searchText !== 'string') return null;
    var trimmed = searchText.trim();
    if (!trimmed) return null;
    var root = document.querySelector('main#MainContent') || document.body;
    var tags = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'DIV', 'P', 'SPAN'];
    for (var i = 0; i < tags.length; i++) {
      var els = root.querySelectorAll(tags[i]);
      for (var j = 0; j < els.length; j++) {
        if (els[j].textContent.trim() === trimmed) return els[j];
      }
    }
    return null;
  }

  document.addEventListener('DOMContentLoaded', function() {
    var mainContent = document.querySelector('main#MainContent');
    if (!mainContent) return;

    var tocWrappers = document.querySelectorAll('.bd-benefits-list__toc-wrapper');
    var footer = document.querySelector('.shopify-section-group-group-footer');

    tocWrappers.forEach(function(tocWrapper) {
      if (tocWrapper.parentNode) {
        mainContent.appendChild(tocWrapper);
      }

      var sectionId = tocWrapper.getAttribute('data-section-id');
      var alignSection = sectionId
        ? document.getElementById('shopify-section-' + sectionId)
        : document.querySelector('.shopify-section--bd-benefits-list');

      var skipTop = parseInt(tocWrapper.getAttribute('data-toc-skip-sections'), 10) || 0;
      var nth = Math.max(1, skipTop + 1);
      var firstSection = mainContent.querySelector('.shopify-section:nth-child(' + nth + ')');
      var alignOffset = parseInt(tocWrapper.getAttribute('data-toc-align-offset'), 10);
      if (isNaN(alignOffset)) alignOffset = 50;

      if (!firstSection || !alignSection) return;

      var alignFixedElement = function() {
        var section = alignSection;
        if (!section) return;
        var sectionTop = section.getBoundingClientRect().top + window.pageYOffset + alignOffset;
        tocWrapper.style.top = sectionTop + 'px';
      };

      var wasAbsolute = false;
      var absoluteReason = null;

      var updateTocPosition = function() {
        var firstSectionRect = firstSection.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var viewportHeight = window.innerHeight;
        var threshold = 10;
        var isFirstSectionInView = firstSectionRect.bottom > threshold;
        var isFooterInView = false;
        var footerTop = 0;
        if (footer) {
          var footerRect = footer.getBoundingClientRect();
          footerTop = footerRect.top + scrollTop;
          isFooterInView = footerRect.top < viewportHeight;
        }
        var shouldBeAbsolute = false;
        var newAbsoluteReason = null;
        if (isFirstSectionInView) {
          shouldBeAbsolute = true;
          newAbsoluteReason = 'firstSection';
        } else if (isFooterInView && footer) {
          shouldBeAbsolute = true;
          newAbsoluteReason = 'footer';
        }
        if (shouldBeAbsolute) {
          if (!wasAbsolute || absoluteReason !== newAbsoluteReason) {
            tocWrapper.classList.add('bd-toc--absolute');
            if (newAbsoluteReason === 'firstSection') {
              alignFixedElement();
            } else if (newAbsoluteReason === 'footer') {
              var wrapperParent = tocWrapper.parentElement;
              if (wrapperParent) {
                var parentRect = wrapperParent.getBoundingClientRect();
                var parentTopAbsolute = parentRect.top + scrollTop;
                var tocHeight = tocWrapper.offsetHeight || 400;
                var gap = 20;
                var absoluteTop = footerTop - parentTopAbsolute - tocHeight - gap;
                tocWrapper.style.top = Math.max(0, absoluteTop) + 'px';
              }
            }
            wasAbsolute = true;
            absoluteReason = newAbsoluteReason;
          } else if (absoluteReason === 'firstSection') {
            alignFixedElement();
          } else if (absoluteReason === 'footer' && footer) {
            var wrapperParent2 = tocWrapper.parentElement;
            if (wrapperParent2) {
              var parentRect2 = wrapperParent2.getBoundingClientRect();
              var parentTopAbsolute2 = parentRect2.top + scrollTop;
              var tocHeight2 = tocWrapper.offsetHeight || 400;
              var gap2 = 20;
              var absoluteTop2 = footerTop - parentTopAbsolute2 - tocHeight2 - gap2;
              tocWrapper.style.top = Math.max(0, absoluteTop2) + 'px';
            }
          }
        } else {
          if (wasAbsolute) {
            tocWrapper.classList.remove('bd-toc--absolute');
            tocWrapper.style.top = '';
            wasAbsolute = false;
            absoluteReason = null;
          }
        }
      };

      setTimeout(updateTocPosition, 100);
      var ticking = false;
      var handleUpdate = function() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            updateTocPosition();
            ticking = false;
          });
          ticking = true;
        }
      };
      window.addEventListener('scroll', handleUpdate);
      window.addEventListener('resize', function() {
        if (wasAbsolute && absoluteReason === 'firstSection') {
          alignFixedElement();
        }
        handleUpdate();
      });
    });

    var tocBlocks = document.querySelectorAll('.bd-table-of-contents');
    tocBlocks.forEach(function(tocBlock) {
      var tocItems = tocBlock.querySelectorAll('.bd-toc-item');
      var tocLinks = tocBlock.querySelectorAll('.bd-toc-item-link');

      tocLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          var anchorId = this.getAttribute('data-anchor-id');
          var scrollToClass = this.getAttribute('data-scroll-to-class');
          var customSelector = this.getAttribute('data-custom-selector');
          var scrollToText = this.getAttribute('data-scroll-to-text');
          var targetElement = null;
          if (customSelector) {
            targetElement = document.querySelector(customSelector);
          } else if (anchorId) {
            targetElement = document.getElementById(anchorId);
          } else if (scrollToClass) {
            targetElement = document.querySelector('.' + scrollToClass);
          } else if (scrollToText) {
            targetElement = findElementByExactText(scrollToText);
          }
          if (targetElement) {
            var offset = 100;
            var targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
          }
        });
      });

      var lastActiveItem = null;
      var lastActiveItemIndex = -1;
      function updateActiveItem() {
        var scrollPosition = window.scrollY + 200;
        var activeItem = null;
        var activeItemIndex = -1;
        tocItems.forEach(function(item, index) {
          var link = item.querySelector('.bd-toc-item-link');
          if (!link) return;
          var anchorId = link.getAttribute('data-anchor-id');
          var scrollToClass = link.getAttribute('data-scroll-to-class');
          var customSelector = link.getAttribute('data-custom-selector');
          var scrollToText = link.getAttribute('data-scroll-to-text');
          var targetElement = null;
          if (customSelector) {
            targetElement = document.querySelector(customSelector);
          } else if (anchorId) {
            targetElement = document.getElementById(anchorId);
          } else if (scrollToClass) {
            targetElement = document.querySelector('.' + scrollToClass);
          } else if (scrollToText) {
            targetElement = findElementByExactText(scrollToText);
          }
          if (targetElement) {
            var elementTop = targetElement.offsetTop;
            var elementBottom = elementTop + targetElement.offsetHeight;
            item.classList.remove('active');
            if (scrollPosition >= elementTop && scrollPosition < elementBottom) {
              item.classList.add('active');
              activeItem = item;
              activeItemIndex = index;
              lastActiveItem = item;
              lastActiveItemIndex = index;
            }
          }
        });
        if (!activeItem && lastActiveItem && lastActiveItemIndex >= 0) {
          tocItems.forEach(function(item) { item.classList.remove('active'); });
          lastActiveItem.classList.add('active');
          activeItem = lastActiveItem;
          activeItemIndex = lastActiveItemIndex;
        }
        var progressFill = tocBlock.querySelector('.bd-toc-progress-fill');
        var itemsContainer = tocBlock.querySelector('.bd-toc-items');
        if (progressFill && itemsContainer && tocItems.length > 0) {
          if (activeItem && activeItemIndex >= 0) {
            var totalHeight = itemsContainer.offsetHeight;
            var activeItemRect = activeItem.getBoundingClientRect();
            var itemsContainerRect = itemsContainer.getBoundingClientRect();
            var activeItemTop = activeItemRect.top - itemsContainerRect.top;
            var fillPercentage = (activeItemTop / totalHeight) * 100;
            progressFill.style.height = Math.min(100, Math.max(0, fillPercentage)) + '%';
            progressFill.style.top = '0';
          } else {
            progressFill.style.height = '0';
          }
        }
      }
      var tocTicking = false;
      window.addEventListener('scroll', function() {
        if (!tocTicking) {
          window.requestAnimationFrame(function() {
            updateActiveItem();
            tocTicking = false;
          });
          tocTicking = true;
        }
      });
      updateActiveItem();
    });

    var tocWidgetButtons = document.querySelectorAll('.bd-benefits-list__toc-widget-button');
    tocWidgetButtons.forEach(function(button) {
      var blockId = button.id.replace('bd-toc-widget-button-', '');
      var widgetContent = document.getElementById('bd-toc-widget-content-' + blockId);
      var closeButton = widgetContent ? widgetContent.querySelector('.bd-toc-widget-close') : null;
      var closeWidget = function() {
        if (widgetContent) {
          widgetContent.classList.remove('bd-toc-widget-content--open');
          button.setAttribute('aria-expanded', 'false');
        }
      };
      if (widgetContent) {
        button.addEventListener('click', function() {
          widgetContent.classList.add('bd-toc-widget-content--open');
          button.setAttribute('aria-expanded', 'true');
        });
        if (closeButton) closeButton.addEventListener('click', closeWidget);
        var widgetLinks = widgetContent.querySelectorAll('.bd-toc-item-link');
        widgetLinks.forEach(function(link) {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            var anchorId = this.getAttribute('data-anchor-id');
            var scrollToClass = this.getAttribute('data-scroll-to-class');
            var customSelector = this.getAttribute('data-custom-selector');
            var scrollToText = this.getAttribute('data-scroll-to-text');
            var targetElement = null;
            if (customSelector) targetElement = document.querySelector(customSelector);
            else if (anchorId) targetElement = document.getElementById(anchorId);
            else if (scrollToClass) targetElement = document.querySelector('.' + scrollToClass);
            else if (scrollToText) targetElement = findElementByExactText(scrollToText);
            if (targetElement) {
              var offset = 100;
              var targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
              window.scrollTo({ top: targetPosition, behavior: 'smooth' });
              setTimeout(closeWidget, 300);
            }
          });
        });
        var widgetTocItems = widgetContent.querySelectorAll('.bd-toc-item');
        var widgetLastActiveItem = null;
        var widgetLastActiveItemIndex = -1;
        function updateWidgetActiveItem() {
          var scrollPosition = window.scrollY + 200;
          var activeItem = null;
          var activeItemIndex = -1;
          widgetTocItems.forEach(function(item, index) {
            var link = item.querySelector('.bd-toc-item-link');
            if (!link) return;
            var anchorId = link.getAttribute('data-anchor-id');
            var scrollToClass = link.getAttribute('data-scroll-to-class');
            var customSelector = link.getAttribute('data-custom-selector');
            var scrollToText = link.getAttribute('data-scroll-to-text');
            var targetElement = null;
            if (customSelector) targetElement = document.querySelector(customSelector);
            else if (anchorId) targetElement = document.getElementById(anchorId);
            else if (scrollToClass) targetElement = document.querySelector('.' + scrollToClass);
            else if (scrollToText) targetElement = findElementByExactText(scrollToText);
            if (targetElement) {
              var elementTop = targetElement.offsetTop;
              var elementBottom = elementTop + targetElement.offsetHeight;
              item.classList.remove('active');
              if (scrollPosition >= elementTop && scrollPosition < elementBottom) {
                item.classList.add('active');
                activeItem = item;
                activeItemIndex = index;
                widgetLastActiveItem = item;
                widgetLastActiveItemIndex = index;
              }
            }
          });
          if (!activeItem && widgetLastActiveItem && widgetLastActiveItemIndex >= 0) {
            widgetTocItems.forEach(function(item) { item.classList.remove('active'); });
            widgetLastActiveItem.classList.add('active');
            activeItem = widgetLastActiveItem;
            activeItemIndex = widgetLastActiveItemIndex;
          }
          var widgetProgressFill = widgetContent.querySelector('.bd-toc-progress-fill');
          var widgetItemsContainer = widgetContent.querySelector('.bd-toc-items');
          if (widgetProgressFill && widgetItemsContainer && widgetTocItems.length > 0) {
            if (activeItem && activeItemIndex >= 0) {
              var totalHeight = widgetItemsContainer.offsetHeight;
              var activeItemRect = activeItem.getBoundingClientRect();
              var itemsContainerRect = widgetItemsContainer.getBoundingClientRect();
              var activeItemTop = activeItemRect.top - itemsContainerRect.top;
              var fillPercentage = (activeItemTop / totalHeight) * 100;
              widgetProgressFill.style.height = Math.min(100, Math.max(0, fillPercentage)) + '%';
              widgetProgressFill.style.top = '0';
            } else {
              widgetProgressFill.style.height = '0';
            }
          }
        }
        var widgetTicking = false;
        window.addEventListener('scroll', function() {
          if (!widgetTicking) {
            window.requestAnimationFrame(function() {
              updateWidgetActiveItem();
              widgetTicking = false;
            });
            widgetTicking = true;
          }
        });
        updateWidgetActiveItem();
      }
    });
  });
})();
